export const siteConfig = {
    lastUpdated: "October 08, 2025",
};